<template lang="pug">
  v-list-item(
    v-on="$listeners"
    :input-value="inputValue"
    :value="outputValue"
    :ripple="false"
    inactive
  )
    v-list-item-content
      v-list-item-title {{ displayText }}
    v-list-item-action
      v-icon(
        :size="20"
        @click.stop="() => $emit('edit', item)"
      ) $ui-edit
</template>

<script>
import DvBtn from '../../buttons/DvBtn.vue';
import get from 'lodash/get';

export default {
  components: {
    DvBtn,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
    itemText: {
      type: String,
      required: true,
    },
    itemValue: {
      type: String,
      required: true,
    },
    inputValue: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    displayText() {
      const { item, itemText } = this;
      return get(item, itemText);
    },
    outputValue() {
      const { item, itemValue } = this;
      return get(item, itemValue);
    },
  },
};
</script>
